import angular from 'angular';
import { REFUND_CAUSES as refundCauses } from 'src/app/core/constants';

angular.module('history').directive('historySale', () => ({
    restrict: 'E',
    replace: true,
    scope: {
        sale: "="
    },
    template: require('./history-sale.html'),
    controller: historySaleController
}));

historySaleController.$inject = [
    "$scope",
    "$filter",
    "$mdSidenav",
    "$translate",
    "saleDocumentsViewer",
    "util",
    "HistorySalesService"
];

function historySaleController(
    $scope,
    $filter,
    $mdSidenav,
    $translate,
    saleDocumentsViewer,
    util,
    HistorySalesService
) {

    $scope.closeSidenav = function() {
        $mdSidenav('historySale').close();
    };

    $scope.getCustomerCaption = () => $scope.sale.customer_tax_code || util.getCustomerCaption($scope.sale.sale_customer);

    $scope.isEInvoice = () => $scope.sale?.e_invoice?.invoice_progressive ? true : false;

    $scope.priceChangeDescription = (price_change) => {
        if (price_change.description) {
            return price_change.type.endsWith('_perc') ? `${price_change.description} (${price_change.value}%)` : price_change.description;
        }

        switch(price_change.type) {
            case 'discount_fix':
                return $translate.instant('HISTORY.SALE.DISCOUNT');
            case 'surcharge_fix':
                return $translate.instant('HISTORY.SALE.SURCHARGE');
            case 'discount_perc':
                return $translate.instant('HISTORY.SALE.DISCOUNT_PERCENTAGE', { value: price_change.value });
            case 'surcharge_perc':
                return $translate.instant('HISTORY.SALE.SURCHARGE_PERCENTAGE', { value: price_change.value });
            case 'gift':
                return $translate.instant('HISTORY.SALE.GIFT');
            default:
                break;
        }
    };

    $scope.refundVoid = () => HistorySalesService.refundVoid($scope.sale);

    $scope.getRowPrice = (sale_item) => $filter('sclCurrency')(sale_item.price * sale_item.quantity, $scope.sale.$currency, $scope.sale.$digits);

    $scope.showSaleDocuments = function() {
        saleDocumentsViewer.openDialog({
            data: {
                sale: $scope.sale
            }
        });
    };

    $scope.isCreditNote = () => $scope.sale.final_amount < 0;

    $scope.printCourtesyReceipt = () => HistorySalesService.printCourtesyReceipt($scope.sale); 
}